// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    quotes_find_quotes: 'Buscando entre los presupuestos',
    quotes_quote_detail: 'Leyendo el presupuesto',
    quotes_summary: 'Sumando los presupuestos',
    quotes_search_catalog: 'Buscando en el catálogo',
    quotes_price_history: 'Mirando lo que solemos cobrar',
    quotes_find_templates: 'Buscando entre las plantillas',
    quotes_draft_quote: 'Preparando el presupuesto',
    quotes_add_lines: 'Añadiendo líneas al presupuesto',
    quotes_link_to_project: 'Archivando el presupuesto en la obra',
    quotes_save_rule: 'Apuntando el criterio',
    quotes_accept_quote: 'Registrando el sí del cliente',
    quotes_send_quote: 'Enviando el presupuesto al cliente',
  },
  ca: {
    quotes_find_quotes: 'Cercant entre els pressupostos',
    quotes_quote_detail: 'Llegint el pressupost',
    quotes_summary: 'Sumant els pressupostos',
    quotes_search_catalog: 'Cercant al catàleg',
    quotes_price_history: 'Mirant el que acostumem a cobrar',
    quotes_find_templates: 'Cercant entre les plantilles',
    quotes_draft_quote: 'Preparant el pressupost',
    quotes_add_lines: 'Afegint línies al pressupost',
    quotes_link_to_project: 'Arxivant el pressupost a l’obra',
    quotes_save_rule: 'Anotant el criteri',
    quotes_accept_quote: 'Registrant el sí del client',
    quotes_send_quote: 'Enviant el pressupost al client',
  },
  en: {
    quotes_find_quotes: 'Looking through the quotes',
    quotes_quote_detail: 'Reading the quote',
    quotes_summary: 'Adding up the quotes',
    quotes_search_catalog: 'Searching the catalogue',
    quotes_price_history: 'Checking what we usually charge',
    quotes_find_templates: 'Looking through the templates',
    quotes_draft_quote: 'Drafting the quote',
    quotes_add_lines: 'Adding lines to the quote',
    quotes_link_to_project: 'Filing the quote under the job',
    quotes_save_rule: 'Writing down the criterion',
    quotes_accept_quote: 'Recording the customer\'s yes',
    quotes_send_quote: 'Sending the quote to the customer',
  },
  fr: {
    quotes_find_quotes: 'Recherche parmi les devis',
    quotes_quote_detail: 'Lecture du devis',
    quotes_summary: 'Bilan des devis',
    quotes_search_catalog: 'Recherche dans le catalogue',
    quotes_price_history: 'Ce que nous facturons d’habitude',
    quotes_find_templates: 'Recherche parmi les modèles',
    quotes_draft_quote: 'Préparation du devis',
    quotes_add_lines: 'Ajout de lignes au devis',
    quotes_link_to_project: 'Rattachement du devis à l’affaire',
    quotes_save_rule: 'Enregistrement du critère',
    quotes_accept_quote: 'Enregistrement de l’accord du client',
    quotes_send_quote: 'Envoi du devis au client',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
